module.exports = __webpack_public_path__ + "img/pause.374e46b7.svg";